import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchProductCodes, fetchedProductCodes } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchActionPayload = ReturnType<typeof fetchProductCodes>;

export function* getProductCodesSaga({ meta: { callback } }: FetchActionPayload) {
  const { getProductCodes } = getAPI();
  const response: YieldOf<typeof getProductCodes> = yield call(getProductCodes);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedProductCodes(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedProductCodes(undefined, error));
  }

  if (callback) callback();
}

export default function* productCodesSaga() {
  yield takeLatest(fetchProductCodes.type, getProductCodesSaga);
}
